import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { clearAuthState, isCredentialSession } from "../../helper/utils";
import {
  INTERNAL_LOGIN_ROUTE,
  LOGIN_ROUTE,
  SAML_AUTHN_STARTED,
} from "../../helper/constants";
import "./styles.scss";

export default function LoggedOut() {
  // Read during the first render, before the effect below wipes sessionStorage.
  // Computing it inline would return true on mount and false on every later
  // render, flipping the retry button's target mid-page.
  const [wasCredentialSession] = useState(isCredentialSession);

  // Wipe client state after server/OAM logout lands here. Must NOT run before
  // OAM SLO — that needs cookies still set (see Header logoutHandler).
  useEffect(() => {
    console.warn("[auth] LoggedOut mounted; clearing client auth state");
    try {
      clearAuthState();
    } catch (e) {
      console.warn("[auth] clearAuthState threw on mount, ignoring", e);
    }
  }, []);

  // The button is rendered as a real <a href> via MUI's component="a" prop.
  // That matters: if anything in JS (click handler, clearAuthState, an
  // unrelated runtime error elsewhere on the page) ever blew up before
  // window.location.href was assigned, the click looked like a no-op —
  // exactly the symptom users were reporting. With an <a href> the browser
  // performs a native navigation no matter what JS does. The onClick still
  // runs synchronously *before* the browser follows the href, so storage
  // is still wiped on the way out.
  //
  // We do NOT call e.preventDefault(), do NOT redirect to OAM full logout
  // from this page (OAM cascades a SAML LogoutRequest back at us), and do
  // NOT route through "/" (which would walk the SSO gate's
  // hasSession/returnedFromSSO branches). The very next request after the
  // click is GET /saml2/authenticate/oamfed -> Spring SAML2 AuthN -> OAM.
  // After a credential login there is no OAM to go back to; the param'd route
  // walks the gate with no session and lands on the login form.
  const retryHref = wasCredentialSession ? INTERNAL_LOGIN_ROUTE : LOGIN_ROUTE;

  const handleRetryLogin = (e) => {
    if (wasCredentialSession) {
      return;
    }
    if (sessionStorage.getItem(SAML_AUTHN_STARTED) === "true") {
      e.preventDefault();
      console.warn("[auth] LoggedOut.retry blocked — SAML login already in flight");
      return;
    }
    console.warn("[auth] LoggedOut.retry → " + LOGIN_ROUTE);
    sessionStorage.setItem(SAML_AUTHN_STARTED, "true");
    sessionStorage.setItem("sso_initiated", "true");
  };

  return (
    <div className="error-page">
      <div className="imgwrapper">
        {/* <img src={NotFoundImg} alt="not found" /> */}
      </div>
      <div className="error-info">
        <p className="title"> Logged Out</p>
      </div>
      <Button
        component="a"
        href={retryHref}
        onClick={handleRetryLogin}
        variant="contained"
        sx={{
          width: "300px",
          height: "50px",
          background: "#3535f3 !important",
          borderRadius: "16px",
          fontWeight: "bold",
          marginTop: "10px",
          textDecoration: "none",
        }}
      >
        Try Logging In again!
      </Button>
    </div>
  );
}
